import Vue from 'vue'
import router from '@/router'
import {
  TOKEN,
  REDIRECT_URL,
  ACCOUNT_INFO,
} from "@/store/mutation-types";
import permissionApi from "@/request/api-manager/permission.js";

//同步设置帐户信息
function setAccount() {
  return new Promise((resolve, reject) => {
    permissionApi.getPermission().then((res) => {
      Vue.ls.set(ACCOUNT_INFO, res.result)
    })
    resolve()
  })
}

var redirectStatus = false
router.beforeEach((to, from, next) => {
  const redirect = decodeURIComponent(from.query.redirect || to.query.redirect || to.path)
  let loginStatus = Vue.ls.get(TOKEN) == null ? false : true
  setAccount()

  if (loginStatus) {
    if (redirect && redirect.indexOf('/edit-page') === 0 && redirect.indexOf("?") > 0) {
      // 跳转到编辑页面
      window.location.href = window.location.origin + redirect;
      return;
    }
  }

  if (redirectStatus && loginStatus) { //是否登陆并且是否重定向
    redirectStatus = false;
    next()
  } else if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
    if (loginStatus == true) { // 判断当前的token是否存在
      Vue.ls.set(REDIRECT_URL, to.fullPath, 60 * 60 * 1000)
      if (to.path === redirect && redirect) {
        redirectStatus = true
        // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
        next()
        // next({ ...to, replace: true })
      } else {
        // 跳转到目的路由
        redirectStatus = true
        if (redirect && redirect != 'null') {
          next({
            path: redirect
          })
        } else {
          next();
        }
      }
    } else {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        } // 将跳转的路由path作为参数，登录成功后跳转到该路由
      });
    }
  } else {
    next();
  }
});